import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import { Menu, ChefHat } from 'lucide-react';

export default function Layout() {
    const { user, loading } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    if (loading) {
        return (
            <div className="min-h-screen bg-[#020617] flex items-center justify-center">
                <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 border-4 border-[#d4af37]/30 border-t-[#d4af37] rounded-full animate-spin" />
                    <p className="text-[#94a3b8]">Chargement...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="min-h-screen bg-[#020617]">
            {/* Mobile Header */}
            <header className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-[#0f172a] border-b border-white/5 px-4 py-3">
                <div className="flex items-center justify-between">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="p-2 text-[#94a3b8] hover:text-white"
                        data-testid="mobile-menu-btn"
                    >
                        <Menu className="w-6 h-6" />
                    </button>
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-lg bg-[#d4af37]/10 flex items-center justify-center">
                            <ChefHat className="w-5 h-5 text-[#d4af37]" />
                        </div>
                        <span className="text-[#f8fafc] font-bold">Traiteur Hub</span>
                    </div>
                    <div className="w-10" /> {/* Spacer for centering */}
                </div>
            </header>

            {/* Sidebar */}
            <Sidebar 
                isOpen={sidebarOpen} 
                onClose={() => setSidebarOpen(false)} 
            />

            {/* Main Content */}
            <main className="
                min-h-screen
                pt-16 lg:pt-0
                lg:ml-56 xl:ml-64
                transition-all duration-300
            ">
                <div className="p-4 sm:p-6 lg:p-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
